// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

import { NonSkuCaratWeightRangeFragmentDoc } from './nonSkuCaratWeightRange.fragment.generated';
import { NonSkuPriceRangeFragmentDoc } from './nonSkuPriceRange.fragment.generated';
import { MoneyFragmentDoc } from '../../../fragments/money.fragment.generated';
import { StoneShapeFragmentDoc } from './stoneShape.fragment.generated';
import { AssetFragmentDoc } from '../../../fragments/asset.fragment.generated';
import { StoneShapeTranslationFragmentDoc } from './stoneShapeTranslation.fragment.generated';
import { StoneColorFragmentDoc } from '../../gems/fragments/StoneColor.fragment.generated';
import { StoneColorTranslationFragmentDoc } from '../../gems/fragments/StoneColorTranslation.fragment.generated';
export const NonSkuLabGrownDiamondBoundsFragmentDoc = `
    fragment nonSkuLabGrownDiamondBounds on NonSkuLabGrownDiamondsBounds {
  __typename
  caratWeight {
    ...nonSkuCaratWeightRange
  }
  price(currency: $currency, country: $country) {
    ...nonSkuPriceRange
  }
  shapes {
    ...stoneShape
  }
  colors {
    ...stoneColor
  }
}
    `;